module.exports = __webpack_public_path__ + "static/media/mazaZoleWon_50_75.bcb58316.png";